<template>
  <div :class="{ 'fill-background': fillBackground }">
    <div class="error-state">
      <SvgIconRunningWithErrors v-if="icon === 'top' || icon === 'left'" :class="iconClass"/>
      <div class="text-block" :class="textAlignClass">
        <h3>Ocorreu um erro inesperado</h3>
        <p>Atualize a página. Se o erro persistir, entre em contato conosco</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseErrorState',

  props: {
    icon: {
      type: String,
      default: ''
    },
    align: {
      type: String,
      default: 'center'
    },
    fillBackground: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    iconClass() {
      return {
        'icon-top': this.icon === 'top',
        'icon-left': this.icon === 'left'
      };
    },
    textAlignClass() {
      return {
        'align-start': this.align === 'start',
        'align-center': this.align === 'center',
        'align-end': this.align === 'end'
      };
    }
  }
}
</script>

<style lang="scss" scoped>
$blue-dark: nth($colors-custom, 1);
$blue-light: nth($colors-custom, 2);

.fill-background {
  display: flex;
  color: $blue-dark;
  background: rgba($blue-light, 0.08);
  width: 100%;
  border-radius: 15px;
  align-items: center;
}

.error-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center; // this ensures vertical centering within its parent
  width: 100%; // make sure it takes the full width of its parent
  height: 100%; // make sure it takes the full height of its parent
  color: $blue-dark;
}

.icon-top,
.icon-left {
  width: 40px;
  height: 40px;
}

h3, p {
  font-family: 'Montserrat', sans-serif;
  font-size: 12px;
  line-height: 16px;
  color: $blue-dark;
}

h3 {
  font-weight: 600;
  margin: 0 0 10px 0;
}

p {
  font-weight: 400;
}

.text-block, .error-state > div {
  text-align: center;

  &.align-start {
    text-align: start;
  }

  &.align-center {
    text-align: center;
  }

  &.align-end {
    text-align: end;
  }
}

svg {
  fill: $blue-dark;
  margin: 0 0 15px 0;
}
</style>
